export default "__VITE_ASSET__ea7d87c8__"